<template>
	<div>
		<div class="card mb-0 shadow" v-if="!editar_vulnerabilidade">
			<div class="card-body">
				<div class="tab-content">
					<div class="animate__animated animate__fadeIn">
						<div class="row">
							<div class="col-12">
								<h4 class="font-weight-bold">
									Vulnerabilidades
									<b-link variant="info" v-b-popover.hover.right="
										'As informações de vulnerabilidades são retiradas do portuário da familia, na aba mais informações.'
									">
										<i class="fas fa-info-circle"></i>
									</b-link>
								</h4>
							</div>
							<load v-if="loading_vunerabilidades" mode="table" />
							<div v-else class="col-12">
								<form-select class="px-0" v-model="medida_vulnerabilidades" :multiple="true"
									:disabled="true" :itens="vulnerabilidades" />
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<h4 class="font-weight-bold">
									Violação de Direitos
									<b-link variant="info" v-b-popover.hover.right="
										'Utilize este Quadro para registrar situações de violência e/ou violação de direitos, atuais ou recentes, ocorridas com membros da família. Estas situações podem ter sido detectas pelo profissional do CREAS durante o medida da família/indivíduo, ou já serem de conhecimento prévio, no caso em que constituem a razão pela qual a família foi incluída em acompanhamento pelo PAEFI.'
									">
										<i class="fas fa-info-circle"></i>
									</b-link>
								</h4>
							</div>
							<div class="col-md-12">
								<div v-if="!novo_vulnerabilidade" class="animate__animated animate__fadeIn">
									<div class="row">
										<div class="col-12">
											<div class="d-flex align-items-center justify-content-between mb-4">
												<div>
													<div class="input-group mb-3">
														<b-input :placeholder="
															$t(
																'Type to search'
															)
														" class="form-control search-input" type="text" v-model="search" v-on:change="
	getVulnerabilidades
" aria-describedby="input-search" />
														<div class="input-group-append" role="button">
															<span class="input-group-text" id="input-search"><i
																	class="fas fa-search search-icon" /></span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<load mode="table" v-if="loadingVulnerabilidades" />
										<div class="col-12" v-else>
											<b-table :fields="[
												{
													key: 'protocolo',
													label: $t('Detalhes'),
												},
												{
													key: 'cadastrado',
													label: $t('Data'),
												},
												{
													key: 'status_nome',
													label: $t('Status'),
												},
												{
													key: 'actions',
													label: '',
													class: 'text-right',
													thStyle: {
														width: '95px',
														minWidth: '95px',
													},
												},
											]" :items="vulnerabilidadesList" :responsive="true" striped hover show-empty small outlined
												stacked="md" table-class="mb-3">
												<template v-slot:cell(protocolo)="data">
													Usuário(s):<br />
													<ul>
														<li v-for="pessoa in data
															.item
															.pessoas_objetos" :key="pessoa.id">
															<b>{{
																pessoa.nome_completo
															}}</b>
														</li>
													</ul>
													Protocolo:
													<b>{{
														data.item.protocolo
													}}</b>
													<br />
													Violações:
													<b>
														<a @click.prevent="
															getViolacoes(
																data.item
																	.violacoes_nomes,
																data.item
															)
														" href="#" v-if="
	data.item
		.violacoes_nomes
		.length > 0
">
															Ver Situações ({{
																data.item
																	.violacoes_nomes
																	.length
															}})</a>
													</b>
													<br />
													Unidade:
													<b>{{
														data.item.unidade
														? data.item.unidade
															.nome
														: ""
													}}</b>
													<br />
													Técnico:
													<b>{{
														data.item.responsavel
														? data.item
															.responsavel
															.nome
														: ""
													}}</b>
												</template>
												<template v-slot:cell(cadastrado)="data">
													{{ data.item.cadastrado }}
												</template>
												<template v-slot:cell(status_nome)="data">
													<span class="small" v-html="
														data.item
															.status_nome
													"></span>
												</template>
												<template v-slot:cell()="data">
													<button
														@click="
															vddSelecionadaId =
															data.item.id;
														editar_vulnerabilidade = true;
															                                                                                                                                                                                                                                                                                                                              "
														class="px-2 mb-0 btn btn-sm btn-success">
														<i class="mdi mdi-square-edit-outline" />
													</button>
												</template>
												<template v-slot:empty="scope">
													<div class="text-center my-5">
														<img :alt="
															$t('No results')
														" class="mb-5" src="/img/icons/robot.svg" style="
	                                                                                  max-height: 165px;
	                                                                              " />
														<h3 class="bold">
															{{
																$t(
																	"No records found"
																)
															}}
														</h3>
													</div>
												</template>
											</b-table>

											<div class="row align-items-center">
												<div class="col-lg-6 col-md-12">
													<div class="form-group d-inline-flex mb-0">
														<select class="form-control" style="width: 70px" v-model="perPage"
															v-on:change="
																getVulnerabilidades
															">
															<option value="5">
																5
															</option>
															<option value="10">
																10
															</option>
															<option value="25">
																25
															</option>
															<option value="50">
																50
															</option>
														</select>
													</div>
													<div class="d-inline-flex ml-2">
														<b-pagination :per-page="perPage" :total-rows="
															pagination.total
														" @change="changePage" v-model="page" />
													</div>
												</div>
												<div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
													<div class="float-lg-right">
														{{ $t("Showing page") }}
														{{
															pagination.currentPage
														}}
														{{ $t("of") }}
														{{
															pagination.totalPages
														}}
														{{ $t("pages in") }}
														{{ pagination.total }}
														{{ $t("records") }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<EditarVulnerabilidade v-else :morph="true" :morph-vulnerabilidade-id="vddSelecionadaId"
			@voltar="editar_vulnerabilidade = false" />
		<ModalVerViolacoes v-if="vddSelecionada" :itens="violacoes" :dados="vddSelecionada" />
	</div>
</template>
<script>
import ModalVerViolacoes from "@modules/ViolenciaViolacaoDireito/Resources/assets/js/includes/ModalVerViolacoes";
import NovoVulnerabilidade from "@modules/ViolenciaViolacaoDireito/Resources/assets/js/Add";
import EditarVulnerabilidade from "@modules/ViolenciaViolacaoDireito/Resources/assets/js/Edit";
export default {
	props: ["medida"],
	components: {
		NovoVulnerabilidade,
		EditarVulnerabilidade,
		ModalVerViolacoes,
	},
	name: "vulnerabilidades",
	metaInfo() {
		return {
			title: this.$i18n.t("vulnerabilidades"),
		};
	},
	data() {
		return {
			familia: {},
			novo_vulnerabilidade: false,
			editar_vulnerabilidade: false,
			loading_vunerabilidades: false,
			TipovulnerabilidadesList: [],
			vulnerabilidadesList: [],
			vulnerabilidades: [],
			vulnerabilidadeSelected: "",
			medida_vulnerabilidades: [],
			page: 1,
			search: "",
			perPage: 10,
			loadingVulnerabilidades: true,
			loading: true,
			violacoes: [],
			vddSelecionada: "",
			vddSelecionadaId: "",
			pagination: {
				currentPage: 0,
				perPage: 0,
				total: 0,
				totalPages: 0,
			},
		};
	},
	mounted() {
		if (typeof this.$route.query.item === "object") {
			this.familia = this.$route.query.familia_id;
		} else {
			this.getFamilia();
		}
		if (this.medida.familia_id.vulnerabilidades) {
			this.medida_vulnerabilidades = JSON.parse(
				this.medida.familia_id.vulnerabilidades
			);
		}
		this.getVulnerabilidades();
		this.getInformacaoCampos();
	},
	methods: {
		getInformacaoCampos() {
			this.loading_vunerabilidades = true;
			axios
				.get(`api/dashboard/atendimento/get/imformacao/campo`)
				.then((response) => {
					this.vulnerabilidades = response.data.vunerabilidades;
				})
				.finally(() => {
					this.loading_vunerabilidades = false;
				});
		},
		getViolacoes(value, vddSelecionada) {
			this.violacoes = value;
			this.vddSelecionada = vddSelecionada;
			this.$bvModal.show("modalVerViolacoes");
		},
		getVulnerabilidades() {
			this.loadingVulnerabilidades = true;
			axios
				.get("api/dashboard/violacaodedireitos", {
					params: {
						id: this.$route.query.familia_id,
						// morph_type: "Medidas",
						// morph_id: this.medida.id,
						page: this.page,
						search: this.search,
						perPage: this.perPage,
					},
				})
				.then((response) => {
					this.vulnerabilidadesList = response.data.data;
					this.pagination = response.data.pagination;

					if (
						this.pagination.totalPages < this.pagination.currentPage
					) {
						this.page = this.pagination.totalPages;
						this.getVulnerabilidades();
					} else {
						this.loadingVulnerabilidades = false;
					}
				})
				.catch(() => {
					this.loadingVulnerabilidades = false;
				});
		},
		changePage(page) {
			if (
				page > 0 &&
				page <= this.pagination.totalPages &&
				page !== this.page
			) {
				this.page = page;
				this.getVulnerabilidades();
			}
		},
		redirectVulnerabilidade(id) {
			this.$router.push({
				path: `/dashboard/violacaodedireitos/edit/${id}`,
				query: { familia_id: this.$route.query.familia_id },
			});
		},
		getFamilia() {
			axios
				.get("api/dashboard/familias/" + this.$route.query.familia_id)
				.then((response) => {
					this.familia = response.data.data;
					this.$route.query.familia_id = this.familia.id;
					this.loading = false;
				})
				.catch(() => {
					this.$router.push("/dashboard/familias");
				});
		},
	},
};
</script>
